import Phaser from 'phaser';

const DEFAULT_WORLD_WIDTH = 3840;
const MIN_Y = 100;
const MAX_Y = 560;

export default class FishSystem {
  constructor(scene, options = {}) {
    this.scene = scene;

    this.worldWidth =
      options.worldWidth ?? DEFAULT_WORLD_WIDTH;

    this.fishes = [];
  }

  create(count = 20) {
    for (let index = 0; index < count; index += 1) {
      this.createFish(index);
    }
  }

  createFish(index) {
    const texture =
      index % 5 === 0
        ? 'fishGlow'
        : 'fishSmall';

    const direction =
      Math.random() > 0.5 ? 1 : -1;

    const fish = this.scene.add.image(
      Phaser.Math.Between(
        80,
        this.worldWidth - 80
      ),
      Phaser.Math.Between(
        MIN_Y,
        MAX_Y
      ),
      texture
    );

    const baseScale =
      texture === 'fishGlow'
        ? Phaser.Math.FloatBetween(
            0.55,
            0.9
          )
        : Phaser.Math.FloatBetween(
            0.45,
            0.85
          );

    fish.setScale(baseScale);
    fish.setAlpha(
      Phaser.Math.FloatBetween(
        0.45,
        0.85
      )
    );

    fish.setDepth(
      texture === 'fishGlow'
        ? 0.9
        : 0.7
    );

    fish.setScrollFactor(1);
    
    fish.setFlipX(
      direction < 0
    );

    fish.fishData = {
      direction,
      normalSpeed:
        Phaser.Math.FloatBetween(
          22,
          48
        ),
      currentSpeed:
        Phaser.Math.FloatBetween(
          22,
          48
        ),
      verticalOffset:
        Phaser.Math.FloatBetween(
          0,
          Math.PI * 2
        ),
      verticalSpeed:
        Phaser.Math.FloatBetween(
          0.8,
          1.5
        ),
      verticalAmount:
        Phaser.Math.FloatBetween(
          3,
          10
        ),
      baseY: fish.y,
      fleeingUntil: 0,
      baseScale,
    };

    this.fishes.push(fish);
  }

  update(time, delta) {
    if (
      !this.scene.player ||
      !this.scene.player.active
    ) {
      return;
    }

    const seconds =
      Math.min(delta, 40) / 1000;

    const player =
      this.scene.player;

    this.fishes.forEach((fish) => {
      if (
        !fish.active ||
        !fish.fishData
      ) {
        return;
      }

      const data =
        fish.fishData;

      const distanceX =
        player.x - fish.x;

      const distanceY =
        player.y - fish.y;

      const playerIsClose =
        Math.abs(distanceX) < 150 &&
        Math.abs(distanceY) < 95;

      if (playerIsClose) {
        data.direction =
          distanceX > 0
            ? -1
            : 1;

        data.fleeingUntil =
          time + 850;
      }

      const isFleeing =
        time <
        data.fleeingUntil;

      const targetSpeed =
        isFleeing
          ? 125
          : data.normalSpeed;

      data.currentSpeed =
        Phaser.Math.Linear(
          data.currentSpeed,
          targetSpeed,
          isFleeing
            ? 0.12
            : 0.025
        );

      fish.x +=
        data.direction *
        data.currentSpeed *
        seconds;

      data.verticalOffset +=
        data.verticalSpeed *
        seconds;

      const targetY =
        data.baseY +
        Math.sin(
          data.verticalOffset
        ) *
          data.verticalAmount;

      fish.y =
        Phaser.Math.Linear(
          fish.y,
          targetY,
          0.04
        );

      fish.setFlipX(
        data.direction < 0
      );

      const tailPulse =
        Math.sin(
          time * 0.012 +
          data.verticalOffset
        ) * 0.025;

      fish.setScale(
        data.baseScale *
          (1 + tailPulse),
        data.baseScale *
          (1 - tailPulse)
      );

      if (
        fish.x <
        -100
      ) {
        fish.x =
          this.worldWidth + 100;

        data.baseY =
          Phaser.Math.Between(
            MIN_Y,
            MAX_Y
          );
      }

      if (
        fish.x >
        this.worldWidth + 100
      ) {
        fish.x = -100;

        data.baseY =
          Phaser.Math.Between(
            MIN_Y,
            MAX_Y
          );
      }
    });
  }

  destroy() {
    this.fishes.forEach(
      (fish) => {
        if (fish?.active) {
          fish.destroy();
        }
      }
    );

    this.fishes = [];
  }
}